<template>
  <div>
    <van-tab title="全国榜单">
      <Rank ref="rank"
        v-if="isShowRank"
        :personalArtical="activityAllInfo.personalArtical"
        :chooseCityInfo="chooseCityInfo"
        :switchPeriod="switchPeriod"
        :isSameCity="isSameCity"
        :initialWwipe="initialWwipe"
        :isShowSelf="isShowSelf"
        type="component"
      />
    </van-tab>
    <ProvincePicker ref="provincePicker" :defaultIndex="chooseCityInfo.defaultIndex" @setLocation="handleSetLocation"/>
  </div>
</template>
<script>
import ProvincePicker from '@/summerCamp/components/provincePicker'
import area from '@/summerCamp/components/provincePicker/config/area'
import Rank from './rank'
import { formatDate } from '@/summerCamp/utils/index'

export default {
  props: {
    activityAllInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    ProvincePicker,
    Rank
  },
  data() {
    return {
      initialWwipe: 0, // 初始化期数与当前期数一致
      switchPeriod: 0, // 切换的期数id
      userCurPeriod: -1, // 用户期数
      isRecommend: false,
      page: 1,
      areaNameArr: Object.keys(area),
      switchCityInfo: {},
      currentIndex: 0,
      preClass: 'pre',
      nextClass: 'next'
    }
  },
  computed: {
    // 期数
    swipePeriod() {
      const periods = this.activityAllInfo.activityInfo.period
      if (periods) {
        return periods.filter(item => (+item.status === 1 || +item.status === 2))
      }
      return []
    },
    // 当前城市是否与用户省份相同，相同时才展示自己的排名
    isSameCity() {
      const { personalArtical } = this.activityAllInfo
      return +personalArtical.province_id === +this.chooseCityInfo.id && (+this.userCurPeriod === +this.switchPeriod)
    },
    // 活动开始上传作文展示
    isShowRank() {
      return this.activityAllInfo.activityInfo.activity_status !== 0
    },
    isShowSelf() {
      const { activityInfo, personalArtical } = this.activityAllInfo
      // 审核通过&&同一个城市&&点赞过才展示
      return activityInfo.process_status >= 2 && this.isSameCity && +personalArtical.thumb > 0
    },
    chooseCityInfo() {
      return this.switchCityInfo.id ? this.switchCityInfo : this.activityAllInfo.cityInfo
    },
    disabledFlag() {
      let flag
      if (this.currentIndex === 0) {
        flag = 'pre'
      }
      if (this.currentIndex === this.swipePeriod.length - 1) {
        flag = 'next'
      }
      return flag
    }
  },
  watch: {
    activityAllInfo: {
      async handler(value) {
        if (value.activityInfo.period) {
          const curPeriodArr = value.activityInfo.period
          for (let index = 0; index < curPeriodArr.length; index++) {
            if (curPeriodArr[index].status === 1) {
              this.initialWwipe = index
              this.currentIndex = index
              this.switchPeriod = curPeriodArr[index].id
              this.userCurPeriod = curPeriodArr[index].id
              break
            }
          }
          this.switchPeriod = this.switchPeriod === 0 ? curPeriodArr[curPeriodArr.length - 1].id : this.switchPeriod
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onCityClick() {
      // const { defaultIndex } = this.$refs.cityWrapper.dataset
      // this.$refs.provincePicker.defaultIndex = defaultIndex
      this.$refs.provincePicker.visible = true
      this.$xesLogger.clickMsg({
        params: { clickid: '11.0.4', elemname: '排行榜切换省份' }
      })
    },
    onPre() {
      this.$refs.swipe.prev()
    },
    onNext() {
      this.$refs.swipe.next()
    },
    onChange(index) {
      const { id } = this.swipePeriod[index] || {}
      this.switchPeriod = id
      console.log('当前期数' + id)
      this.currentIndex = index
      this.$xesLogger.clickMsg({
        params: { clickid: '11.0.1', elemname: '点击左右按钮切换人气榜单期数' }
      })
    },
    getDate(item) {
      return `${item.title} (${formatDate(item.start_date)}-${formatDate(item.end_date)})`
    },
    handleSetLocation(data) {
      this.switchCityInfo = data
    }
  }
}
</script>
<style lang="less" scoped>
  .city-wrapper {
    height: 28px;
    margin-bottom: 10px;
    line-height: 28px;
    text-align: right;
    background: linear-gradient(270deg, #ffe3c3 0%, #fffaee 100%);

    .btn-city {
      display: inline-block;
      padding-right: 16px;
    }

    .icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      vertical-align: middle;
      background: url(../../../../assets/images/home/switch_city.png) no-repeat;
      background-size: 100%;
    }

    .city-name {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;
      vertical-align: middle;
      color: #333;
    }
  }

  .periods-swipe {
    position: relative;
    width: 134px;
    margin: 0 auto;
    text-align: center;
    background: #fff;

    .van-swipe-item {
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;
      text-align: center;
      color: #666;
    }

    .pre,
    .next {
      position: absolute;
      top: 50%;
      opacity: 0.6;
      transform: translateY(-50%);
      content: '';
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
    }

    .pre {
      right: 0;
      border-right: 10px solid #e02727;

      &.disabled {
        border-right: 10px solid rgba(153, 153, 153, 0.4);
      }
    }

    .next {
      left: 0;
      border-left: 10px solid #e02727;

      &.disabled {
        border-left: 10px solid rgba(153, 153, 153, 0.4);
      }
    }

    .pre-wrapper,
    .next-wrapper {
      position: absolute;
      top: 0;
      width: 40px;
      height: 100%;
    }

    .pre-wrapper {
      left: 0;
      margin-left: -40px;
    }

    .next-wrapper {
      right: 0;
      margin-right: -40px;
    }
  }
</style>
